module.exports = __webpack_public_path__ + "img/step01.175d930f.png";